import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                                         */
const AppointmentConfirmationInstructions = ({
  isPhone,
  confirmationContent,
  className,
  ...rest
}) => {
  if (!confirmationContent) {
    return null;
  }
  const image = isPhone ? confirmationContent.image?.mobile : confirmationContent.image?.original;
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("appointment-confirmation-instructions", className) }, /* @__PURE__ */ React.createElement(
    Heading,
    {
      variant: "smallest",
      className: classnames("appointment-confirmation-instructions__section-heading", className)
    },
    confirmationContent.title
  ), confirmationContent.image && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: classnames("appointment-confirmation-instructions__image", className),
      src: image?.url,
      alt: confirmationContent.image.description ?? void 0,
      width: image?.width,
      height: image?.height
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("appointment-confirmation-instructions__description", className),
      dangerouslySetInnerHTML: { __html: confirmationContent.description.value }
    }
  ));
};
export {
  AppointmentConfirmationInstructions as default
};
//# sourceMappingURL=AppointmentConfirmationInstructions.js.map
